import { render, staticRenderFns } from "./SoldCredit.vue?vue&type=template&id=623b72a1&scoped=true"
import script from "./SoldCredit.vue?vue&type=script&lang=js"
export * from "./SoldCredit.vue?vue&type=script&lang=js"
import style0 from "./SoldCredit.vue?vue&type=style&index=0&id=623b72a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b72a1",
  null
  
)

export default component.exports